module.exports = __webpack_public_path__ + "img/second.8ed55220.jpg";